export default __webpack_public_path__ + "julie_head.png";